import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {
  saveICCompModel,
  saveICPinModel,
  savePinValue,
  savePowerOff,
  updateComponentPinUsage,
  applyMultiBufferUsageChange,
  reAssignBufferModel,
  saveCopyStimulus,
  changeMultiBufferPage,
  saveExpICPinModel,
  saveEpxICCompModel,
  createNewExpsByModel,
  updateCreateExpStatus,
  removeModelExp,
  openSweep
} from '../../store/multiInterface/action';
import Table from "@/components/EditableTable";
import { CopyOutlined, LoadingOutlined, RedoOutlined, PlusSquareOutlined, CloseOutlined } from '@ant-design/icons';
import { Checkbox, Dropdown, Tooltip, Tree, Popover, Button, Divider, TreeSelect, Spin } from 'antd';
import {
  driverReceiverModelText,
  getModelFileText,
  getPinModels,
  getPinStimulusText,
  settingUnit,
  SIGNAL_CLK,
  SweepData
} from '../../../../services/Sierra';
import ICModelPanel from '../../../../components/ICModelPanel';
import { SIERRA } from '../../../../constants/pageType';
import { getFolderFileDetail, getIbisModelList, getSpiceModelList } from '../../../../services/Sierra/library';
import { getPins } from '../../../../services/Sierra/library/IbisModelHelper';
import PinNodeConnect from '@/components/pinNodeConnect';
import { SPI_TYPES } from '@/services/PCBHelper/constants';
import { copyToClipboard } from '../../../../services/helper/htmlElement';
import { getDefaultName } from '../../../../services/helper/setDefaultName';
import multiSetupBufferDataBase from '../../../../services/Sierra/multiInterfaceSetup/multiSetupBufferDataBase';
import projectVerifications from '../../../../services/Sierra/data/projectVerifications';
import { EXPERIMENTS, VERIFICATION } from '../../../../constants/treeConstants';
import '../index.css';
import { I2C, I3C } from '../../../../services/PCBHelper/constants';

const { SHOW_PARENT } = TreeSelect;
const CLK_NAME_TYPES = ['CLK', 'SCK', 'SCLK', 'SCL'];
const PIN_TYPE = ['Driver', 'Receiver'];
const SINGLE_ADD = "single_add", MODEL_ADD = "model_add";
const columns = [{
  title: "PCB",
  dataIndex: "pcb",
  key: 'pcb',
  textWrap: 'word-break',
  ellipsis: true,
  width: 180,
  fixed: 'left',
},
{
  title: "Part",
  dataIndex: "part",
  key: 'part',
  textWrap: 'word-break',
  ellipsis: true,
  width: 180,
  fixed: 'left',
}, {
  title: "Component",
  dataIndex: "component",
  key: 'component',
  width: 100,
  fixed: 'left',
},
{
  title: "File:Component",
  dataIndex: "componentModel",
  key: 'componentModel',
  fixed: 'left',
  width: 150,
  textWrap: 'word-break',
  ellipsis: true,
},
{
  title: "Pin",
  dataIndex: "pin",
  key: 'pin',
  width: 70,
  fixed: 'left',
},
{
  title: "Usage",
  dataIndex: "usage",
  key: 'usage',
  width: 90,
  fixed: 'left',
},
{
  title: "Model",
  dataIndex: "model",
  key: 'model',
  fixed: 'left',
  width: 170,
},
{
  title: "Stimulus",
  dataIndex: "pinModels",
  key: 'pinModels',
  fixed: 'right',
  width: 120
},
{
  title: "Interfaces",
  dataIndex: "interfaceNames",
  key: 'interfaceNames',
  fixed: 'right',
  width: 120
}];

class BufferTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      createInfo: null,
      sweepMap: {},
      allExps: [],
      checkedCreateKeys: [],
      loadingExp: false
    }
  }

  componentDidMount = () => {
    this.initColumns()
  }

  componentDidUpdate = (prevProps) => {
    const { pageData, loading } = this.props;
    if ((!prevProps.pageData && pageData)
      || (pageData && prevProps.pageData && pageData.length !== prevProps.pageData.length)
      || (prevProps.loading !== loading && !loading)) {
      this.initColumns()
    }
  }

  initColumns = () => {
    let _columns = JSON.parse(JSON.stringify(columns)), sweepMap = {};
    const allData = multiSetupBufferDataBase.getData() || [];
    const filterList = [...new Set(allData.filter(it => it.experiments && it.experiments.length).map(item => item.experiments).flat(2).map(item => {
      if (!sweepMap[item.expName]) {
        sweepMap[item.expName] = {}
      }
      sweepMap[item.expName] = {
        ...sweepMap[item.expName],
        ...(item.sweepIdMap || {})
      }
      return item.expName;
    }))];
    let allExps = [];
    if (filterList.length) {
      let expColumns = []

      for (let expName of filterList) {

        if (!expName || allExps.includes(expName)) {
          continue;
        }
        allExps.push(expName)
        const { newExpColumn } = this.createNewExp({ _expName: expName });
        expColumns.push(newExpColumn)
      }
      _columns.splice(7, 0, ...expColumns);
    }

    _columns[0].render = (text, record) => {
      return <span title={text} className='sierra-multi-buffer-table-span'>{text}</span>
    }

    _columns[0].onCell = (record) => {
      return {
        edit: false,
        rowSpan: record.mergePcbLength,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    }

    _columns[1].render = (text, record) => {
      return <span className='sierra-multi-buffer-table-span' title={text}>{text}</span>
    }

    _columns[1].onCell = (record) => {
      return {
        edit: false,
        rowSpan: record.mergeComponentLength,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    }

    _columns[2].render = (text, record) => {
      return <span>{text}</span>
    }

    _columns[2].onCell = (record) => {
      return {
        edit: false,
        rowSpan: record.mergeComponentLength,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    }

    _columns[3].title = () => {
      const { modelAssignLoading } = this.props;
      return (
        <div>
          <span className='multi-setup-buffer-model-title'>File:Component</span>
          <Tooltip
            title={modelAssignLoading ? "Assigning..." : 'Re-assign buffer model'}
            mouseLeaveDelay={0}
            mouseEnterDelay={0.3}
            classNames={{ root: 'icon-tooltip' }}
          >

            {modelAssignLoading ?
              <LoadingOutlined className="multi-setup-buffer-model-re-match-icon" />
              : <RedoOutlined
                className="multi-setup-buffer-model-re-match-icon"
                onClick={this.props._reAssignBufferModel} />}
          </Tooltip>
        </div >
      );
    }

    _columns[3].render = (text, record) => {
      //model:[files:[ { fileName, folder, libraryId, type,subckt } ]]
      const file = getModelFileText({ model: record.componentModel });
      const component = record.componentModel.files && record.componentModel.files.length > 0 && record.componentModel.files[0].libraryId && record.componentModel.files[0].component
      const _text = `${file}${component ? `: ${component}` : ''}`;

      return <span className='sierra-ic-editable-cell-value-wrap sierra-multi-buffer-table-span'
        title={_text}
      >
        {_text}
      </span>;
    }

    _columns[3].onCell = (record) => {
      return {
        edit: false,
        rowSpan: record.mergeComponentLength,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    }

    _columns[4].onCell = (record) => {
      return {
        edit: false,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    }

    _columns[5].onCell = (record) => {
      return {
        record,
        edit: 'select',
        options: PIN_TYPE,
        dataIndex: 'usage',
        getPopupContainer: document.getElementById("multi-buffer-content-id"),
        handleSave: this.editComponentPinUsage,
        tdClassName: "ant-table-cell ant-table-cell-fix-left"
      }
    };

    _columns[6].title = () => {
      return <div>
        <span>Model</span>
        <Dropdown menu={{
          items: [{ key: SINGLE_ADD, label: 'Create an experiment' }, { key: MODEL_ADD, label: 'Create experiments by model' }],
          onClick: this.addNewExp
        }} overlayClassName='' >
          <Tooltip classNames={{ root: "aurora-tooltip" }} title="Create experiments">
            <PlusSquareOutlined
              className='sierra-multi-interface-buffer-sweep-icon'
            //onClick={(e) => this.addNewExp(e)}
            />
          </Tooltip>
        </Dropdown>
      </div>
    }

    _columns[6].render = (text, record) => {
      const _text = driverReceiverModelText(record, {});
      return <span className='sierra-multi-buffer-table-span' >{_text}</span>;
    }

    _columns[6].onCell = (record) => {
      const { component, usage, componentModel } = record;
      const { ibisList, spiceList } = this.props;
      const text = driverReceiverModelText(record, {});
      return usage ? {
        edit: true,
        record: { ...record, pinModels: JSON.parse(JSON.stringify(record.pinModels || [])) },
        title: `${component} - ${record.pin} ${usage} Model`,
        componentName: component,
        compModel: componentModel,
        customInput: ICModelPanel,
        className: 'sierra-ic-editable-cell-value-wrap',
        product: SIERRA,
        text,
        pins: [],
        dataIndex: 'model',
        displayType: "model",
        ibisList,
        spiceList,
        isMultiSetup: true,
        getIbisModelList: getIbisModelList,
        getSpiceModelList: getSpiceModelList,
        getFolderFileDetail,
        getPins,
        assignModel: this.assignModel,
        saveModelPins: () => { },
        savePowerOff: this._savePowerOff,
        saveLibraryModel: this.saveChipModel,
        tdClassName: "ant-table-cell ant-table-cell-fix-left ant-table-cell-fix-left-last"
      } :
        {
          edit: false,
          tdClassName: "ant-table-cell ant-table-cell-fix-left ant-table-cell-fix-left-last"
        }
    }

    for (let column of _columns) {
      if (column.dataIndex === "pinModels") {
        column.render = (text, record) => {
          const copyStimulusId = `stimulus-copy-${record.pcb}::${record.component}::${record.pin}`;
          const pasteStimulusId = `stimulus-paste-${record.pcb}::${record.component}::${record.pin}`;
          const allowCopy = record.pinModels && record.pinModels.find(item => item.pinName === "nd_in" && !!item.type)
          const { copyStimulus } = this.props;
          const copyDisplay = record.usage === "Driver" && copyStimulus && copyStimulus.id !== copyStimulusId;
          const className = allowCopy && copyDisplay ? "multi-setup-buffer-stimulus-text-1" : (allowCopy || copyDisplay) ? "multi-setup-buffer-stimulus-text-2" : ""
          return (
            <div className="multi-setup-buffer-stimulus-content">
              <span
                className={`multi-setup-buffer-stimulus-text ${className}`}
              >{getPinStimulusText(record.pinModels)}</span>
              {copyDisplay ? <span
                title="Paste Stimulus"
                id={pasteStimulusId}
                className={`iconfont icon-niantie stimulus-paste-setup-icon ${allowCopy ? "" : "stimulus-paste-setup-icon-1"}`}
                onClick={(e) => this.pasteStimulus(e, record, pasteStimulusId)}
              ></span> : null}
              {allowCopy ? <CopyOutlined
                title="Copy Stimulus"
                id={copyStimulusId}
                className={copyDisplay ? "stimulus-copy-setup-icon" : "stimulus-copy-setup-icon stimulus-copy-setup-icon-1"}
                onClick={(e) => this.copyRecordStimulus(e, record, copyStimulusId)} /> : null}
            </div>
          );
        }

        column.onCell = (record) => {
          const { usage, component, componentModel, model, interfaceType, clock, signalType } = record;
          const type = usage === 'Driver' ? 'tx' : 'rx';
          const { vectorList, spiceList } = this.props;
          const pinModels = getPinModels(record.pinModels);
          const text = getPinStimulusText(record.pinModels);
          let _clock = {};
          if (typeof clock === "string" && clock) {
            _clock = settingUnit(clock, "M");
          }
          let defaultDelayValue = ([...SPI_TYPES].includes(interfaceType) && CLK_NAME_TYPES.find(item => record.signal.includes(item))) || ([I2C, I3C].includes(interfaceType) && signalType === SIGNAL_CLK) ? { type: 'percent', value: '35' } : null;
         // const showClock = signalType === SIGNAL_CLK || !signalType;
         // const signalClock = showClock && record.signalClock ? settingUnit(record.signalClock || "", "M") : null;
          return type === 'tx' && record.model ? {
            record,
            edit: true,
            text,
            modelType: "Stimulus",
            pins: [],
            compName: component,
            compModel: componentModel,
            product: SIERRA,
            model,
            isMultiSetup: true,
            className: 'sierra-stimulus-editable-cell-value-wrap',
            customInput: PinNodeConnect,
            pinModels: JSON.parse(JSON.stringify(record.pinModels || [])),//{type:type-seed}
            modelPins: JSON.parse(JSON.stringify(pinModels || [])),//{type,seed}
            displayType: "model",
            vectorList: vectorList,
            dataIndex: 'inputStimulus',
            libraryList: spiceList,
            getPins: getPins,
            getLibraryFile: getSpiceModelList,
            getFolderFileDetail,
            stimulus: this.getStimulus(record),
            saveModelPins: this.saveModelPins,
            savePinStimulusModel: () => { },
            clock: _clock || {},
            applyAll: false,
            defaultDelayValue,
            tdClassName: "ant-table-cell ant-table-cell-fix-right ant-table-cell-fix-right-first",
          /*   signalClock,
            showClock,
            simulationValueCheck */
          } : {
            edit: false,
            tdClassName: "ant-table-cell ant-table-cell-fix-right ant-table-cell-fix-right-first"
          }
        }
      }

      if (column.dataIndex === "interfaceNames") {
        column.render = (text, record) => {
          const names = Object.keys(record.interfaceNames || {});
          return <span className='sierra-multi-buffer-table-interface-span'>{names.join(`,\n`)}</span>;
        }

        column.onCell = (record) => {
          return {
            edit: false,
            tdClassName: "ant-table-cell ant-table-cell-fix-right"
          }
        }
      }
    }

    this.setState({
      columns: _columns,
      sweepMap,
      allExps
    })
  }

  addNewExp = ({ key }) => {
    if (this.state.createVisible || this.props.createExpStatus) {
      return;
    }
    if (key === SINGLE_ADD) {
      this.singleAddExp()
    } else {
      const { pageData } = this.props;
      const findData = pageData.find(it => it.model && it.model.libraryId && it.model.modelName && it.model.libType === "IBIS");
      const findCompData = pageData.find(it => it.componentModel && it.componentModel.files && it.componentModel.files[0]
        && it.componentModel.files[0].fileName && it.componentModel.files[0].type === "IBIS");
      const model = findData ? { ...findData.model } : null;
      const _model = model ? {
        files: [{
          component: "",
          fileName: model.fileName,
          libraryId: model.libraryId,
          modelKey: model.libraryId,
          type: model.libType,
        }]
      } : null
      const compModel = findCompData ? findCompData : null;

      const allData = multiSetupBufferDataBase.getData() || [];
      let dataObj = {}
      for (let data of allData) {
        if (!dataObj[data.pcbId]) {
          dataObj[data.pcbId] = { pcb: data.pcb, components: [] }
        }
        if (dataObj[data.pcbId].components.includes(data.component)) {
          continue;
        }
        dataObj[data.pcbId].components.push(data.component)
      }
      const treeData = [
        {
          title: "All PCB components",
          key: "All",
          value: "All",
          children: [
            ...Object.keys(dataObj).map(pcbId => {
              return {
                title: dataObj[pcbId].pcb,
                key: pcbId,
                value: pcbId,
                children: dataObj[pcbId].components.map(comp => {
                  return {
                    key: `${pcbId}::${comp}`,
                    title: comp,
                    value: `${pcbId}::${comp}`
                  }
                })
              }
            })
          ]
        },
      ]
      this.setState({
        createVisible: true,
        createInfo: {
          bufferModel: _model || compModel,
          usage: "Driver",
          pinModels: getPins({ type: "I/O", usage: "Driver" }),
          model: {}
        },
        checkedCreateKeys: [...Object.keys(dataObj)],
        createCompTreeData: treeData
      })
    }
  }

  singleAddExp = () => {
    const { columns, allExps } = this.state;
    const { expCheckedList } = this.props;
    let _expCheckedList = [...expCheckedList];
    let _columns = [...columns], _allExps = [...allExps];
    let index = columns.findLastIndex(item => item.dataIndex.includes("exp"));
    if (index === -1) {
      index = 6;
    }
    const exps = columns.filter(item => item.dataIndex.includes("exp")).map(item => item.dataIndex);
    const expNames = exps.map(item => { const [key, name] = item.split("::"); return name });
    const { expName, newExpColumn } = this.createNewExp({ expNames });
    _columns.splice(index + 1, 0, newExpColumn);
    this.props._createNewExpsByModel([{ expName }]);
    _expCheckedList.push(expName);
    this.props.updateExpCheckedList(_expCheckedList)
    _allExps.push(expName)
    this.setState({
      columns: _columns,
      allExps: _allExps
    }, () => {
      this.scrollToNewExpColumn(index + 1)
    })
  }

  createExpsByModel = (modelList, interfaceIndex, { applyDriverAll, applyReceiverAll }) => {

    const { columns, allExps, checkedCreateKeys } = this.state;
    const { expCheckedList } = this.props;
    let _expCheckedList = [...expCheckedList];
    let _columns = [...columns], _allExps = [...allExps];
    let index = columns.findLastIndex(item => item.dataIndex.includes("exp"));
    if (index === -1) {
      index = 6;
    }
    const exps = columns.filter(item => item.dataIndex.includes("exp")).map(item => item.dataIndex);
    const expNames = exps.map(item => { const [key, name] = item.split("::"); return name });
    let newExpColumns = [], newExps = [];
    for (let modelItem of modelList || []) {
      const pinInfo = modelItem.pinInfo || [];
      const modelInfo = pinInfo[0] || {}
      if (!modelInfo.model) {
        continue
      }
      const { expName, newExpColumn } = this.createNewExp({ expNames, modelInfo });
      expNames.push(expName);
      newExpColumns.push(newExpColumn);
      newExps.push({ expName, modelInfo })
      _expCheckedList.push(expName);
      _allExps.push(expName)
    }
    _columns.splice(index + 1, 0, ...newExpColumns);
    this.props._createNewExpsByModel({ newExps, applyDriverAll, applyReceiverAll, checkedCreateKeys })
    this.props.updateExpCheckedList(_expCheckedList)
    this.setState({
      columns: _columns,
      allExps: _allExps
    }, () => {
      this.scrollToNewExpColumn(index + 1)
    })
  }

  scrollToNewExpColumn = (columnIndex) => {
    if (this.table && this.table.props && columnIndex > 6) {
      const table = ReactDOM.findDOMNode(this.table);
      const tableBody = table ? table.querySelector('.ant-table-body') : null;

      let scrollLeft = 0;
      const columns = this.table.props.columns || [];
      if (!columns.length) {
        return;
      }
      for (let i = 7; i < columnIndex; i++) {
        scrollLeft += 170;
      }

      tableBody.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }
  };

  createNewExp = ({ expNames, _expName }) => {
    const expName = _expName ? _expName : getDefaultName({ nameList: expNames, key: "", defaultKey: "Exp" });
    const dataIndex = `exp::${expName}`;
    let newExpColumn = {
      title: () => {
        const { expCheckedList } = this.props;
        const { sweepMap, openedTooltipExp } = this.state;
        let className = "sierra-multi-buffer-exp-not-create-span";
        let isCreated = false;
        if (sweepMap && sweepMap[expName] && Object.keys(sweepMap[expName]).length) {
          className = "sierra-multi-buffer-exp-created-span";
          isCreated = true;
        }
        const open = openedTooltipExp === expName;
        return <div>
          <Checkbox
            className='sierra-sweep-group-exp-checkbox'
            checked={expCheckedList.includes(expName)} onChange={e => this.checkExpChange(e, expName)}
          />
          <Popover
            classNames={{ root: "sierra-multi-buffer-exp-popover" }}
            trigger="hover"
            content={open && isCreated ? this.getExpTooltip(expName) : null}
            title=""
            open={open && isCreated}
            destroyOnHidden={true}
            onOpenChange={(visible) => this.visibleExpTooltip(visible, expName)}
          ><span
            onMouseEnter={(e) => this.visibleExpTooltip(true, expName)}
            className={className}
          >{expName}</span></Popover>
          <CloseOutlined
            className='sierra-sweep-group-exp-remove-icon'
            title="Remove the experiment"
            onClick={(e) => this.removeExp(e, expName)}
          />
        </div>
      },
      dataIndex,
      key: dataIndex,
      width: 170,
      render: (value, record) => {
        const findExp = (record.experiments || []).find(it => it.expName === expName) || {};
        const text = driverReceiverModelText({ pin: record.pin, usage: record.usage, model: findExp.model }, { isExp: true })
        return <span className='sierra-multi-buffer-table-span sierra-multi-buffer-exp-span'>{text}</span>
      },
      onCell: (record) => {
        const { component, usage, componentModel } = record;
        const { ibisList, spiceList } = this.props;
        const findExp = (record.experiments || []).find(it => it.expName === expName) || {};
        const text = driverReceiverModelText({ pin: record.pin, usage: record.usage, model: findExp.model }, { isExp: true });
        return usage ? {
          edit: true,
          record: {
            ...record,
            model: { ...findExp.model },
            deviceVcc: findExp.deviceVcc,
            powerOff: findExp.powerOff,
            pinModels: JSON.parse(JSON.stringify(findExp.pinModels || [])),
            expName
          },
          title: `${expName} - ${component} - ${record.pin} ${usage} Model`,
          componentName: component,
          compModel: componentModel,
          customInput: ICModelPanel,
          className: 'sierra-ic-editable-cell-value-wrap',
          product: SIERRA,
          text,
          pins: [],
          dataIndex: 'model',
          displayType: "model",
          ibisList,
          spiceList,
          isMultiSetup: true,
          getIbisModelList: getIbisModelList,
          getSpiceModelList: getSpiceModelList,
          getFolderFileDetail,
          getPins,
          assignModel: (info) => this.assignExpModel({ ...(info || {}), expName }),
          saveModelPins: () => { },
          savePowerOff: () => { },
          saveLibraryModel: () => { },
          isGroupExp: true
        } :
          {
            edit: false,
          }
      }
    }

    return { newExpColumn, expName };
  }

  visibleExpTooltip = async (visible, expName) => {
    if (!visible) {
      this.setState({
        openedTooltipExp: null
      })
      return
    }
    this.setState({
      openedTooltipExp: visible ? expName : null,
      loadingExp: expName
    }, async () => {
      const { sweepMap } = this.state;
      let currSweepIdMap = sweepMap[expName] || {};
      if (!Object.keys(currSweepIdMap).length) {
        this.setState({
          loadingExp: false
        })
        return null;
      }
      for (let verId of Object.keys(currSweepIdMap)) {
        await SweepData.getData(verId);
      }
      this.setState({
        loadingExp: false
      })
    })
  }

  getExpTooltip = (expName) => {
    const { sweepMap, loadingExp } = this.state;
    const { panelHeight } = this.props;
    let currSweepIdMap = sweepMap[expName] || {};
    /*  if (!Object.keys(currSweepIdMap).length) {
       return null;
     } */
    let treeData = [];
    for (let verId of Object.keys(currSweepIdMap)) {
      const ver = projectVerifications.getVer(verId);
      const sweepIds = currSweepIdMap[verId] || [];
      let sweepList = []
      for (let id of sweepIds) {
        const sweep = SweepData.getSweep(id, verId);
        if (!sweep) {
          continue;
        }
        sweepList.push({
          title: sweep ? sweep.name : id,
          key: id,
          disabled: !sweep ? true : false,
          dataType: EXPERIMENTS,
          verificationId: verId
        })
      }

      /*     experiments = await SweepData.getData(verId); */
      if (!sweepList.length || !ver) {
        continue;
      }
      treeData.push({
        title: ver.name,
        key: verId,
        dataType: VERIFICATION,
        selectable: false,
        children: sweepList
      })
    }
    return <Spin spinning={loadingExp && loadingExp === expName} size="small" tip="Loading List...">
      <div className='sierra-multi-buffer-exp-title-content' style={{ maxHeight: panelHeight - 250 }}>
        {treeData.length ? <Tree
          treeData={treeData}
          defaultExpandAll
          checkable={false}
          selectable={true}
          onSelect={this.selectSweep}
        /> : null}
      </div>
    </Spin>
  }

  selectSweep = (keys, selectedNode) => {
    const node = selectedNode.node || {};
    if (node.dataType !== EXPERIMENTS) {
      return;
    }
    this.props._openSweep(node.verificationId, keys[0])
  }

  removeExp = (e, expName) => {
    e && e.stopPropagation();
    const { columns, allExps, sweepMap } = this.state;
    let _expCheckedList = this.props.expCheckedList;
    let _columns = [...columns], _allExps = [...allExps], _sweepMap = { ...sweepMap };
    if (expName === "All") {
      _columns = _columns.filter(item => !item.dataIndex.includes("exp"));
      _expCheckedList = [];
      _allExps = [];
      _sweepMap = {}
    } else {
      _columns = _columns.filter(item => item.dataIndex !== `exp::${expName}`);
      _expCheckedList = _expCheckedList.filter(item => item !== expName);
      _allExps = _allExps.filter(item => item !== expName);
      delete _sweepMap[expName]
    }
    this.setState({
      columns: _columns,
      allExps: _allExps,
      sweepMap: _sweepMap
    })

    this.props.updateExpCheckedList(_expCheckedList)
    this.props._removeModelExp(expName)
  }

  checkExpChange = (e, expName) => {
    const { allExps } = this.state;
    const checked = e.target.checked;
    let _expCheckedList = [...this.props.expCheckedList];
    if (expName === "All") {
      _expCheckedList = checked ? [...allExps] : [];
    } else {
      if (checked) {
        _expCheckedList.push(expName);
        _expCheckedList = [...new Set(_expCheckedList)]
      } else {
        _expCheckedList = _expCheckedList.filter(item => item !== expName);
      }
    }

    this.props.updateExpCheckedList(_expCheckedList)
  }

  getStimulus(record) {
    const pins = record.pinModels;
    let stimulus, pinName;
    if (!pins) {
      return { stimulus, pinName };
    }
    for (let pin of pins) {
      if (pin.stimulus) {
        pinName = pin.pinName;
        stimulus = pin.stimulus;
      }
    };
    return { stimulus, pinName }
  }

  copyRecordStimulus = (e, record, copyId) => {
    e && e.stopPropagation();
    copyToClipboard(e, "", copyId);
    this.props._saveCopyStimulus({ id: copyId, pinModels: JSON.parse(JSON.stringify(record.pinModels || [])) })
  }

  pasteStimulus = (e, record) => {
    e && e.stopPropagation();
    const { copyStimulus } = this.props;
    if (!copyStimulus || !copyStimulus.pinModels || !copyStimulus.pinModels.length) {
      return;
    }
    const pinModels = JSON.parse(JSON.stringify(copyStimulus.pinModels));
    pinModels.forEach(item => {
      const findItem = record.pinModels.find(it => it.pinName === item.pinName && ["nd_pu", "nd_pd"].includes(item.pinName));
      if (findItem) {
        item.voltage = findItem.voltage;
      }
    })
    this.props._savePinValue({ record, pinModels, applyAll: false });
  }

  assignModel = ({ record, model, deviceVcc, pinModelsInfo, applyAll, powerOff }) => {
    this.props.saveModel({ record, model, deviceVcc, pinModelsInfo, applyAll, powerOff });
  }

  saveModelPins = ({ record, pinModels, applyAll, applyAllDriver }) => {
    this.props._savePinValue({ record, pinModels, applyAll, applyAllDriver });
  }

  _savePowerOff = ({ record, powerOff, applyAll }) => {
    //this.props.savePowerOffMode(record, powerOff, applyAll);
  }

  saveChipModel = ({ files, libType, record }) => {
    const { pcb, component } = record;
    this.props._saveICCompModel({ files, libType, pcb, component });
  }

  assignExpModel = ({ record, expName, model, deviceVcc, pinModelsInfo, applyAll, applyGroupAll, applyPCBAll, powerOff }) => {
    this.props.saveExpModel({ record, expName, model, deviceVcc, pinModelsInfo, applyAll, applyGroupAll, applyPCBAll, powerOff });
  }

  saveExpChipModel = ({ files, libType, record }) => {
    const { pcb, component } = record;
    this.props._saveExpICCompModel({ files, libType, pcb, component });
  }

  editComponentPinUsage = (record) => {
    this.props._updateComponentPinUsage(record)
  }

  onPageChange = (page) => {
    this.props._changeMultiBufferPage(page)
  }

  closeModal = () => {
    this.setState({
      createVisible: false
    })
  }

  getCheckboxRender = () => {
    const { checkedCreateKeys, createCompTreeData } = this.state;
    return <div className='sierra-multi-buffer-create-exp-tree-select-content'>
      <span>Filter PCB components</span>
      <TreeSelect
        className='sierra-multi-buffer-create-exp-tree-select aurora-tree-select'
        treeCheckable={true}
        showCheckedStrategy={SHOW_PARENT}
        treeDefaultExpandedKeys={["All"]}
        value={checkedCreateKeys}
        onChange={(checkedKeys) => this.checkCreateCompKeys(checkedKeys)}
        treeData={createCompTreeData}
      />
    </div>
  }

  checkCreateCompKeys = (checkedKeys) => {
    const { createCompTreeData } = this.state;
    let keys = [...checkedKeys]
    if (checkedKeys.includes("All")) {
      keys = createCompTreeData[0].children.map(item => item.key)
    }
    this.setState({
      checkedCreateKeys: keys
    })
  }

  render() {
    const { pageData, pageSize, page, allDataLength, panelHeight, createExpStatus, ibisList, spiceList, expCheckedList } = this.props;
    const { columns, createVisible, createInfo, allExps } = this.state;
    //const totalWidth = (columns || []).reduce((sum, col) => sum + (col.width || 50), 0);
    return <Fragment>
      {columns.find(it => it.dataIndex.includes("exp")) ? <div className='sierra-multi-buffer-exp-action-content'>
        <Checkbox
          className='sierra-multi-buffer-group-exp-checkbox-all'
          checked={expCheckedList.length === allExps.length}
          indeterminate={expCheckedList.length && expCheckedList.length < allExps.length}
          onChange={e => this.checkExpChange(e, "All")}
        >
          Checked All Exps
        </Checkbox>
        <Divider type="vertical" />
        <Button type="link" className="sierra-multi-buffer-group-exp-button" onClick={(e) => this.removeExp(e, "All")}>Delete All Exps</Button>
      </div> : null}
      <Table
        columns={columns}
        ref={(ref) => this.table = ref}
        dataSource={JSON.parse(JSON.stringify(pageData || []))}
        className="sierra-multi-buffer-table"
        rowKey={(record) => `${record.pcb}_${record.component}_${record.pin}`}
        size="small"
        pagination={{
          position: ["topRight"],
          pageSize,
          current: page,
          hideOnSinglePage: true,
          onChange: this.onPageChange,
          total: allDataLength,
          showSizeChanger: false
        }}
        style={{ minWidth: columns.length <= 9 ? 1200 : 1500 }}
        //totalWidth
        scroll={{ x: 'max-content', y: panelHeight - 250 }}
        tableLayout="fixed"
      />
      {createVisible ?
        <ICModelPanel
          record={createInfo}
          compModel={createInfo ? createInfo.bufferModel : {}}
          product={SIERRA}
          pins={[]}
          title={"Create New Experiments by Model"}
          dataIndex={'model'}
          displayType={"model"}
          ibisList={ibisList}
          spiceList={spiceList}
          isMultiSetup={true}
          multipleModels={true}
          notSaveModel={true}
          isGroupExp={true}
          createStatus={createExpStatus}
          getIbisModelList={getIbisModelList}
          getSpiceModelList={getSpiceModelList}
          getFolderFileDetail={getFolderFileDetail}
          getPins={getPins}
          saveLibraryModel={() => { }}
          createExpsByModel={this.createExpsByModel}
          updateCreateStatus={this.props.updateCreateExpStatus}
          closeModal={this.closeModal}
          getCheckboxRender={this.getCheckboxRender}
        /> : null}
    </Fragment>
  }
}

const mapState = (state) => {
  const { SierraReducer: { multiInterfaceSetup: { bufferData, copyStimulus, modelAssignLoading, createExpStatus }, library: { libraryTreeInfo } } } = state;
  const { pageData, page, pageSize, allDataLength, usageApplyAll, loading } = bufferData || {};
  return {
    pageData,
    page,
    pageSize,
    allDataLength,
    usageApplyAll,
    copyStimulus,
    libraryTreeInfo,
    modelAssignLoading,
    createExpStatus,
    loading
  }
}

const mapDispatch = (dispatch) => ({
  _saveICCompModel({ files, pcb, component }) {
    dispatch(saveICCompModel({ files, pcb, component }))
  },
  saveModel({ record, model, deviceVcc, pinModelsInfo, applyAll, powerOff }) {
    dispatch(saveICPinModel({ record, model, deviceVcc, pinModelsInfo, applyAll, powerOff }))
  },
  saveExpModel({ record, expName, model, deviceVcc, pinModelsInfo, applyAll, applyGroupAll, applyPCBAll, powerOff }) {
    dispatch(saveExpICPinModel({ record, expName, model, deviceVcc, pinModelsInfo, applyAll, applyGroupAll, applyPCBAll, powerOff }))
  },
  _saveExpICCompModel({ files, pcb, component }) {
    dispatch(saveEpxICCompModel({ files, pcb, component }))
  },
  _savePinValue({ record, pinModels, applyAll, applyAllDriver }) {
    dispatch(savePinValue({ record, pinModels, applyAll, applyAllDriver }));
  },
  savePowerOffMode(record, powerOff, applyAll) {
    dispatch(savePowerOff(record, powerOff, applyAll));
  },
  _updateComponentPinUsage(record) {
    dispatch(updateComponentPinUsage(record))
  },
  applyUsageChange(checked) {
    dispatch(applyMultiBufferUsageChange(checked))
  },
  _reAssignBufferModel() {
    dispatch(reAssignBufferModel())
  },
  _saveCopyStimulus(copyStimulus) {
    dispatch(saveCopyStimulus(copyStimulus))
  },
  _changeMultiBufferPage(page) {
    dispatch(changeMultiBufferPage(page))
  },
  _createNewExpsByModel({ newExps, applyDriverAll, applyReceiverAll, checkedCreateKeys }) {
    dispatch(createNewExpsByModel({ newExps, applyDriverAll, applyReceiverAll, checkedCreateKeys }))
  },
  updateCreateExpStatus(status) {
    dispatch(updateCreateExpStatus(status))
  },
  _removeModelExp(expName) {
    dispatch(removeModelExp(expName))
  },
  _openSweep(verificationId, sweepId) {
    dispatch(openSweep(verificationId, sweepId))
  }
})

export default connect(mapState, mapDispatch)(BufferTable);
